import React from 'react';
import {
  ContextMenu,
  ContextMenuItem,
  Icon,
  Layout,
  LayoutItem,
} from '@axiom/ui';

import type { ChatHistoryItem } from '../../api/chat-api';

export type ChatHistoryRowMenuProps = {
  chat: ChatHistoryItem;
  hide: () => Promise<void>;
  startRename: () => void;
  unhide: () => Promise<void>;
};

export const ChatHistoryRowMenu = ({
  chat,
  hide,
  startRename,
  unhide,
}: ChatHistoryRowMenuProps) => (
  <ContextMenu name={`CHAT_ACTIONS_${chat.id}`} fixed>
    <ContextMenuItem name="RENAME_CHAT" onClick={startRename}>
      <Layout direction="horizontal" position="left middle">
        <Icon name="pencil" />
        <LayoutItem leftGutter="8px" fluid>
          Rename
        </LayoutItem>
      </Layout>
    </ContextMenuItem>

    {chat.deleted ? (
      <ContextMenuItem
        name="UNHIDE_CHAT"
        onClick={async () => {
          await unhide();
        }}
      >
        <Layout direction="horizontal" position="left middle">
          <Icon name="eye" />
          <LayoutItem leftGutter="8px" fluid>
            Unhide
          </LayoutItem>
        </Layout>
      </ContextMenuItem>
    ) : (
      <ContextMenuItem
        name="HIDE_CHAT"
        onClick={async () => {
          await hide();
        }}
      >
        <Layout direction="horizontal" position="left middle">
          <Icon name="eye-hidden" />
          <LayoutItem leftGutter="8px" fluid>
            Hide
          </LayoutItem>
        </Layout>
      </ContextMenuItem>
    )}
  </ContextMenu>
);
